// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ScriptsAuthenticationSaveCurrentUserSaveCurrentUserRequestModel {
    static getAttributeTypeMap() {
        return ScriptsAuthenticationSaveCurrentUserSaveCurrentUserRequestModel.attributeTypeMap;
    }
}
ScriptsAuthenticationSaveCurrentUserSaveCurrentUserRequestModel.discriminator = undefined;
ScriptsAuthenticationSaveCurrentUserSaveCurrentUserRequestModel.additionalProperties = false;
ScriptsAuthenticationSaveCurrentUserSaveCurrentUserRequestModel.attributeTypeMap = [
    {
        "name": "userName",
        "baseName": "userName",
        "type": "string"
    },
    {
        "name": "firstName",
        "baseName": "firstName",
        "type": "string"
    },
    {
        "name": "lastName",
        "baseName": "lastName",
        "type": "string"
    },
    {
        "name": "phone",
        "baseName": "phone",
        "type": "ScriptsAuthenticationSaveCurrentUserSaveCurrentUserContactInfoRequestModel"
    },
    {
        "name": "fax",
        "baseName": "fax",
        "type": "ScriptsAuthenticationSaveCurrentUserSaveCurrentUserContactInfoRequestModel"
    },
    {
        "name": "email",
        "baseName": "email",
        "type": "ScriptsAuthenticationSaveCurrentUserSaveCurrentUserContactInfoRequestModel"
    },
];
//# sourceMappingURL=scriptsAuthenticationSaveCurrentUserSaveCurrentUserRequestModel.js.map